import { Keyboard } from './keyboard/Keyboard';
export class Devices {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    keyboard = new Keyboard(this);
}
